import { makeGraphQLRequest } from '../../utils/requestUtils';

export async function requestOrganizationById(orgId, userId) {
    const query = `query requestOrganizaionById(
    $orgId: ID, $userId: ID
  ) {
      organization(id: $orgId) {
        name
        cageCode
        iconStatus
        users {
          name
          email
          faxNumber
          phoneNumber
          role
          id
          iconStatus
          cageCode
        }
      }
      user(id: $userId) {
        
        organizationId 
        role
      }
    }`;

    const variables = { orgId, userId };
    const response = await makeGraphQLRequest({
        query,
        variables,
    });

    return response;
}

export async function requestUsersWithProcAuthority(orgId) {
    const query = `query requestUsersWithProcAuthority($orgId: ID ) {
    users {
      name
      email
      faxNumber
      phoneNumber
      role
      id
      iconStatus
    }
  }`;

    const variables = { orgId };
    const response = await makeGraphQLRequest({
        query,
        variables,
    });

    return response;
}


// export async function updateUserMetaData(userId, orgId) {
//   const query =
//     'mutation updateUserMetaData($userId: ID, $orgId: ID) { updateUserMetaData(userId: $userId, orgId: $orgId) { name } }';
//   const variables = { userId, orgId };
//   const response = await makeGraphQLRequest({
//     query,
//     variables,
//   });
//   return response;
// }



// WEBPACK FOOTER //
// ./src/pages/AccountAdmin/graphql.js